import React from 'react';
import Loader, { LoaderType } from '../Loader/Loader';

interface Props {
  children: React.ReactNode;
}

const AppLoader: React.FC<Props> = ({ children }) => (
  <React.Suspense fallback={<Loader type={LoaderType.FULL_PAGE} />}>
    {children}
  </React.Suspense>
);

export default AppLoader;
